import React, { useContext, useEffect, useState } from 'react'
import Login from 'containers/Login'
import Loader from 'components/Loader'
import api from 'services/api'
import { UnauthorizedError } from 'services/api/errors/auth'
import { takePendingLoginLink } from 'services/login-link'
import authContext from 'contexts/auth'

interface Props {
  children: React.ReactNode
}

const Authenticated = ({ children }: Props): React.ReactElement => {
  const [loading, setLoading] = useState(true)
  const [loginLinkInvalid, setLoginLinkInvalid] = useState(false)
  const authCtx = useContext(authContext)

  useEffect(() => {
    const authenticate = async () => {
      // A login link from an e-mail wins over a session that might still be
      // alive, because the link is what the user has just asked for.
      const loginLinkToken = takePendingLoginLink()
      if (loginLinkToken) {
        try {
          await api.loginWithToken(loginLinkToken)
        } catch (error) {
          // unknown, expired or redeemed already; any other error (such as the
          // server being down) is reported by the session check below anyway
          if (error instanceof UnauthorizedError) {
            setLoginLinkInvalid(true)
          }
        }
      }

      // send test request to verify if user is logged in
      try {
        await api.getStatus()
        authCtx.setAuthenticated(true)
      } catch (err) {
        authCtx.setAuthenticated(false)
      } finally {
        setLoading(false)
      }
    }
    authenticate()
  }, [authCtx])

  if (loading) {
    return <Loader/>
  }

  if (!authCtx.authenticated) {
    return <Login loginLinkInvalid={loginLinkInvalid}/>
  }

  // continue to protected part
  return <>{children}</>
}

export default Authenticated
